export default {
  agency: {
    include_agency_brand: true,
    include_agency_invoice_pdf: true,
    include_agency_quote_pdf: true,
    include_agency_sensitive_data: true,
    include_locked_by_user: true,
  },
  agencyOrderBundle: {
    include_agency_order_bundle_agency: true,
  },
  agencyProvider: {
    include_agency_provider_provider: true,
    include_agency_provider_provider_price_list: true,
  },
  agencyProviderPriceOverride: {
    include_agency_provider_price_overrides_price_list: true,
    include_provider_price_list_items: true,
    include_provider_price_list_products: true,
  },
  agencyProviderDeadlineGroup: {
    include_agency_deadline_group_deadline_group: true,
    include_agency_provider_deadline_group_provider: true,
  },
  agent: {
    include_agent_user: true,
  },
  apiKey: {
    include_api_key_user: true,
  },
  apiLog: {
    include_api_actioned_by_user: true,
  },
  attachment: {
    include_attachment_file: true,
  },
  brand: {
    include_attachment_file: true,
    include_brand_logo: true,
    include_brand_marketing_cover_image: true,
    include_brand_mono_logo: true,
    include_brand_public_link_logo: true,
    include_brand_public_link_cover_image: true,
  },
  brandTheme: {
    include_brand_theme_brand: true,
  },
  comment: {
    include_comment_user: true,
  },
  contract: {
    include_contract_attachments: true,
  },
  conversation: {
    include_conversation_comments: true,
    skip_notifications: true,
  },
  customFieldSet: {
    include_custom_field_set_fields: true,
  },
  font: {
    include_font_file: true,
  },
  fontFamily: {
    include_font_family_font_count: true,
  },
  image: {
    include_image_sizes: true,
  },
  notification: {
    include_notification_image: true,
  },
  orderBundle: {
    include_order_bundle_items: true,
  },
  orderBundleItem: {
    include_order_bundle_item_price_list: true,
    include_order_bundle_item_provider: true,
    include_order_bundle_item_publication: true,
  },
  orderLeadTime: {
    include_order_lead_time_orderable: true,
  },
  portalOption: {
    include_portal_option_values: true,
  },
  processingFee: {
    include_processing_fee_billable: true,
  },
  provider: {
    include_provider_alternate_logo: true,
    include_provider_bank_account: true,
    include_provider_billing: true,
    include_provider_invoice_pdf: true,
    include_provider_logo: true,
    include_provider_stripe_integration: true,
  },
  providerDisclaimer: {
    include_provider_disclaimer_service_product: true,
  },
  providerOrderCode: {
    include_provider_order_code_price_list: true,
    include_provider_order_code_service_product: true,
  },
  providerPackage: {
    include_provider_package_agencies_count: true,
    include_provider_package_provider: true,
  },
  providerPriceList: {
    include_provider_price_list_item_option_value_price_list_id: true,
    include_provider_price_list_item_option_values: true,
    include_provider_price_list_item_options: true,
    include_provider_price_list_items: true,
    include_provider_price_list_products: true,
  },
  providerProductCode: {
    include_provider_product_code_product: true,
  },
  publication: {
    include_publication_logo: true,
  },
  publicationCompatiblePagination: {
    include_publication_compatible_pagination_compatible_publication: true,
  },
  publicationOption: {
    include_publication_option_values: true,
  },
  publicationSpecialDeadline: {
    include_publication_special_deadline_publication_edition: true,
  },
  serviceProduct: {
    include_publication_provider: true,
    include_service_product_assigned_publications: true,
    include_service_product_editorial_publications: true,
    include_service_product_compatible_products: true,
  },
  teamMember: {
    include_image_sizes: true,
    include_team_member_user: true,
    include_user_image: true,
  },
  tag: {
    include_tag_image: true,
    include_tag_owner: true,
  },
  templatePageCategory: {
    include_template_page_category_brand: true,
  },
  user: {
    include_user_association_id: true,
    include_user_authentication_token: true,
    include_user_google_authentication_token: true,
    include_user_realhub_platform: true,
  },
}
